export default "__VITE_ASSET__DDXcV_cP__";